var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b14618b66dec0df16f7e4878f04dc3967e1bc324"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engineering-management@skill-recordings"]={id:"b14618b66dec0df16f7e4878f04dc3967e1bc324"};
      